import { createContext, useEffect, useState, useReducer, useRef } from "react";
import { auth, db } from "../firebase/firebase";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import axios from "axios";
import { MoralisProvider } from "react-moralis";
import { getAllPrices } from "../new-prices/priceService";

const INITIAL_STATE = {
  currentUser: null,
  currentAccount: "practice",
  currentWallet: "walletconnect",
};

const userReducer = function (state, action) {
  switch (action.type) {
    case "login":
      return { currentUser: action.payload };
    case "register":
      return { currentUser: action.payload };
    case "logout":
      return { currentUser: null };
    case "switchAccount":
      return { currentAccount: action.payload };
    case "setWalletConnect":
      return { currentWallet: action.payload };
    default:
      return state.currentUser;
  }
};

export const userContext = createContext(INITIAL_STATE);

const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(userReducer, INITIAL_STATE);
  const [user, loading] = useAuthState(auth);
  const [userData, setUserData] = useState({});
  const [accounts, setAccounts] = useState({});
  const [btcPrice, setBtcPrice] = useState("");
  const [ethPrice, setEthPrice] = useState("");
  const [solPrice, setSolPrice] = useState("");
  const [bchPrice, setBchPrice] = useState("");
  const [ltcPrice, setLtcPrice] = useState("");
  const [dogePrice, setDogePrice] = useState("");
  const [usdtPrice, setUsdtPrice] = useState("");
  const [maticPrice, setMaticPrice] = useState("");
  const [avaxPrice, setAvaxPrice] = useState("");

  // Stocks
  const [aaplPrice, setAaplPrice] = useState("");
  const [abtPrice, setAbtPrice] = useState("");
  const [adbePrice, setAdbePrice] = useState("");
  const [adiPrice, setAdiPrice] = useState("");
  const [aemdPrice, setAemdPrice] = useState("");
  const [aigPrice, setAigPrice] = useState("");
  const [amcPrice, setAmcPrice] = useState("");
  const [amdPrice, setAmdPrice] = useState("");
  const [amtPrice, setAmtPrice] = useState("");
  const [amznPrice, setAmznPrice] = useState("");
  const [aptPrice, setAptPrice] = useState("");
  const [asmlPrice, setAsmlPrice] = useState("");
  const [aterPrice, setAterPrice] = useState("");
  const [axpPrice, setAxpPrice] = useState("");
  const [baPrice, setBaPrice] = useState("");
  const [babaPrice, setBabaPrice] = useState("");
  const [bacPrice, setBacPrice] = useState("");
  const [biduPrice, setBiduPrice] = useState("");
  const [bmyPrice, setBmyPrice] = useState("");
  const [cPrice, setCPrice] = useState("");
  const [catPrice, setCatPrice] = useState("");
  const [ccoPrice, setCcoPrice] = useState("");
  const [ceiPrice, setCeiPrice] = useState("");
  const [chwyPrice, setChwyPrice] = useState("");
  const [clPrice, setClPrice] = useState("");
  const [cleuPrice, setCleuPrice] = useState("");
  const [cmcsaPrice, setCmcsaPrice] = useState("");
  const [costPrice, setCostPrice] = useState("");
  const [crdfPrice, setCrdfPrice] = useState("");
  const [crmPrice, setCrmPrice] = useState("");
  const [cscoPrice, setCscoPrice] = useState("");
  const [cvxPrice, setCvxPrice] = useState("");
  const [disPrice, setDisPrice] = useState("");
  const [ebayPrice, setEbayPrice] = useState("");
  const [fbPrice, setFbPrice] = useState("");
  const [fslyPrice, setFslyPrice] = useState("");
  const [gePrice, setGePrice] = useState("");
  const [gevoPrice, setGevoPrice] = useState("");
  const [gmPrice, setGmPrice] = useState("");
  const [googlPrice, setGooglPrice] = useState("");
  const [gsPrice, setGsPrice] = useState("");
  const [hdPrice, setHdPrice] = useState("");
  const [honPrice, setHonPrice] = useState("");
  const [ibmnPrice, setIbmPrice] = useState("");
  const [inmdPrice, setInmdPrice] = useState("");
  const [intcPrice, setIntcPrice] = useState("");
  const [jnjPrice, setJnjPrice] = useState("");
  const [jpmPrice, setJpmPrice] = useState("");
  const [koPrice, setKoPrice] = useState("");
  const [lenPrice, setLenPrice] = useState("");
  const [lvsPrice, setLvsPrice] = useState("");
  const [maPrice, setMaPrice] = useState("");
  const [mdlzPrice, setMdlzPrice] = useState("");
  const [mmmPrice, setMmmPrice] = useState("");
  const [mnstPrice, setMnstPrice] = useState("");
  const [moPrice, setMoPrice] = useState("");
  const [mrinPrice, setMrinPrice] = useState("");
  const [mrkPrice, setMrkPrice] = useState("");
  const [msPrice, setMsPrice] = useState("");
  const [msiPrice, setMsiPrice] = useState("");
  const [msftPrice, setMsftPrice] = useState("");
  const [nflxPrice, setNflxPrice] = useState("");
  const [nkePrice, setNkePrice] = useState("");
  const [nvdaPrice, setNvdaPrice] = useState("");
  const [nvsPrice, setNvsPrice] = useState("");
  const [orclPrice, setOrclPrice] = useState("");
  const [pepPrice, setPepPrice] = useState("");
  const [pfePrice, setPfePrice] = useState("");
  const [pgPrice, setPgPrice] = useState("");
  const [pyplPrice, setPyplPrice] = useState("");
  const [racePrice, setRacePrice] = useState("");
  const [rklbPrice, setRklbPrice] = useState("");
  const [rlPrice, setRlPrice] = useState("");
  const [rwlkPrice, setRwlkPrice] = useState("");
  const [sbuxPrice, setSbuxPrice] = useState("");
  const [snapPrice, setSnapPrice] = useState("");
  const [ssrmPrice, setSsrmPrice] = useState("");
  const [sqPrice, setSqPrice] = useState("");
  const [tPrice, setTPrice] = useState("");
  const [tevaPrice, setTevaPrice] = useState("");
  const [tmPrice, setTmPrice] = useState("");
  const [tmusPrice, setTmusPrice] = useState("");
  const [tripPrice, setTripPrice] = useState("");
  const [tslaPrice, setTslaPrice] = useState("");
  const [tsmPrice, setTsmPrice] = useState("");
  const [twtrPrice, setTwtrPrice] = useState("");
  const [unhPrice, setUnhPrice] = useState("");
  const [vPrice, setVPrice] = useState("");
  const [vzPrice, setVzPrice] = useState("");
  const [wfcPrice, setWfcPrice] = useState("");
  const [wmtPrice, setWmtPrice] = useState("");
  const [xomPrice, setXomPrice] = useState("");

  // Totals
  const [cryptoTotal, setCryptoTotal] = useState("");
  const [stockTotal, setStockTotal] = useState("");
  const [totalBalance, setTotalBalance] = useState("");
  const [account, setAccount] = useState([]);
  const [live, setLive] = useState([]);
  const [practice, setPractice] = useState([]);
  const [fiatTotal, setFiatTotal] = useState("");
  const currentAccount = state.currentAccount;

  // Crypto extra
  const [oneInchPrice, setOneInchPrice] = useState("");
  const [aavePrice, setAavePrice] = useState("");
  const [algoPrice, setAlgoPrice] = useState("");
  const [ancPrice, setAncPrice] = useState("");
  const [apePrice, setApePrice] = useState("");
  const [auroraPrice, setAuroraPrice] = useState("");
  const [axsPrice, setAxsPrice] = useState("");
  const [btgPrice, setBtgPrice] = useState("");
  const [boringPrice, setBoringPrice] = useState("");
  const [adaPrice, setAdaPrice] = useState("");
  const [xcnPrice, setXcnPrice] = useState("");
  const [linkPrice, setLinkPrice] = useState("");
  const [cmdxPrice, setCmdxPrice] = useState("");
  const [croPrice, setCroPrice] = useState("");
  const [daiPrice, setDaiPrice] = useState("");
  const [daoPrice, setDaoPrice] = useState("");
  const [dashPrice, setDashPrice] = useState("");
  const [manaPrice, setManaPrice] = useState("");
  const [dflPrice, setDflPrice] = useState("");
  const [nrgPrice, setNrgPrice] = useState("");
  const [etcPrice, setEtcPrice] = useState("");
  const [evmosPrice, setEvmosPrice] = useState("");
  const [gtPrice, setGtPrice] = useState("");
  const [goPrice, setGoPrice] = useState("");
  const [lnPrice, setLnPrice] = useState("");
  const [xmrPrice, setXmrPrice] = useState("");
  const [nexoPrice, setNexoPrice] = useState("");
  const [okbPrice, setOkbPrice] = useState("");
  const [opPrice, setOpPrice] = useState("");
  const [ognPrice, setOgnPrice] = useState("");
  const [ornPrice, setOrnPrice] = useState("");
  const [dotPrice, setDotPrice] = useState("");
  const [xprPrice, setXprPrice] = useState("");
  const [rainiPrice, setRainiPrice] = useState("");
  const [rariPrice, setRariPrice] = useState("");
  const [sfpPrice, setSfpPrice] = useState("");
  const [shibPrice, setShibPrice] = useState("");
  const [xlmPrice, setXlmPrice] = useState("");
  const [stepPrice, setStepPrice] = useState("");
  const [gmtPrice, setGmtPrice] = useState("");
  const [sushiPrice, setSushiPrice] = useState("");
  const [tlosPrice, setTlosPrice] = useState("");
  const [xtzPrice, setXtzPrice] = useState("");
  const [grtPrice, setGrtPrice] = useState("");
  const [trxPrice, setTrxPrice] = useState("");
  const [uniPrice, setUniPrice] = useState("");
  const [vetPrice, setVetPrice] = useState("");
  const [wingPrice, setWingPrice] = useState("");
  const [wxtPrice, setWxtPrice] = useState("");
  const [timePrice, setTimePrice] = useState("");
  const [zecPrice, setZecPrice] = useState("");
  const [zigPrice, setZigPrice] = useState("");

  const [profits, setProfits] = useState(undefined);

  const [addresses, setAddresses] = useState([]);
  const [signalBalance, setSignalBalance] = useState("");

  const backupPricesFetching = useRef(false);

  async function applyBackupPrices() {
    if (backupPricesFetching.current) return;
    backupPricesFetching.current = true;

    const priceSetters = {
      "1INCH": setOneInchPrice,
      AAVE: setAavePrice,
      ADA: setAdaPrice,
      ALGO: setAlgoPrice,
      ANC: setAncPrice,
      APE: setApePrice,
      AURORA: setAuroraPrice,
      AVAX: setAvaxPrice,
      AXS: setAxsPrice,
      BCH: setBchPrice,
      BTC: setBtcPrice,
      BTG: setBtgPrice,
      BORING: setBoringPrice,
      CRO: setCroPrice,
      DAI: setDaiPrice,
      DAO: setDaoPrice,
      DASH: setDashPrice,
      DOGE: setDogePrice,
      DOT: setDotPrice,
      ETC: setEtcPrice,
      ETH: setEthPrice,
      EVMOS: setEvmosPrice,
      GMT: setGmtPrice,
      GRT: setGrtPrice,
      GT: setGtPrice,
      GO: setGoPrice,
      LINK: setLinkPrice,
      LN: setLnPrice,
      LTC: setLtcPrice,
      MANA: setManaPrice,
      MATIC: setMaticPrice,
      NEXO: setNexoPrice,
      OGN: setOgnPrice,
      OKB: setOkbPrice,
      OP: setOpPrice,
      ORN: setOrnPrice,
      XCN: setXcnPrice,
      CMDX: setCmdxPrice,
      DFL: setDflPrice,
      NRG: setNrgPrice,
      XMR: setXmrPrice,
      XPR: setXprPrice,
      RAINI: setRainiPrice,
      RARI: setRariPrice,
      SFP: setSfpPrice,
      SHIB: setShibPrice,
      SOL: setSolPrice,
      XLM: setXlmPrice,
      STEP: setStepPrice,
      SUSHI: setSushiPrice,
      TLOS: setTlosPrice,
      TRX: setTrxPrice,
      UNI: setUniPrice,
      USDT: setUsdtPrice,
      VET: setVetPrice,
      WING: setWingPrice,
      WXT: setWxtPrice,
      TIME: setTimePrice,
      XTZ: setXtzPrice,
      ZEC: setZecPrice,
      ZIG: setZigPrice,
      AAPL: setAaplPrice,
      ABT: setAbtPrice,
      ADBE: setAdbePrice,
      ADI: setAdiPrice,
      AEMD: setAemdPrice,
      AIG: setAigPrice,
      AMC: setAmcPrice,
      AMD: setAmdPrice,
      AMT: setAmtPrice,
      AMZN: setAmznPrice,
      APT: setAptPrice,
      ASML: setAsmlPrice,
      ATER: setAterPrice,
      AXP: setAxpPrice,
      BA: setBaPrice,
      BABA: setBabaPrice,
      BAC: setBacPrice,
      BIDU: setBiduPrice,
      BMY: setBmyPrice,
      C: setCPrice,
      CAT: setCatPrice,
      CCO: setCcoPrice,
      CEI: setCeiPrice,
      CHWY: setChwyPrice,
      CL: setClPrice,
      CLEU: setCleuPrice,
      CMCSA: setCmcsaPrice,
      COST: setCostPrice,
      CRDF: setCrdfPrice,
      CRM: setCrmPrice,
      CSCO: setCscoPrice,
      CVX: setCvxPrice,
      DIS: setDisPrice,
      EBAY: setEbayPrice,
      FB: setFbPrice,
      FSLY: setFslyPrice,
      GE: setGePrice,
      GEVO: setGevoPrice,
      GM: setGmPrice,
      GOOGL: setGooglPrice,
      GS: setGsPrice,
      HD: setHdPrice,
      HON: setHonPrice,
      IBM: setIbmPrice,
      INMD: setInmdPrice,
      INTC: setIntcPrice,
      JNJ: setJnjPrice,
      JPM: setJpmPrice,
      KO: setKoPrice,
      LEN: setLenPrice,
      LVS: setLvsPrice,
      MA: setMaPrice,
      MDLZ: setMdlzPrice,
      MMM: setMmmPrice,
      MNST: setMnstPrice,
      MO: setMoPrice,
      MRIN: setMrinPrice,
      MRK: setMrkPrice,
      MS: setMsPrice,
      MSFT: setMsftPrice,
      MSI: setMsiPrice,
      NFLX: setNflxPrice,
      NKE: setNkePrice,
      NVDA: setNvdaPrice,
      NVS: setNvsPrice,
      ORCL: setOrclPrice,
      PEP: setPepPrice,
      PFE: setPfePrice,
      PG: setPgPrice,
      PYPL: setPyplPrice,
      RACE: setRacePrice,
      RKLB: setRklbPrice,
      RL: setRlPrice,
      RWLK: setRwlkPrice,
      SBUX: setSbuxPrice,
      SNAP: setSnapPrice,
      SQ: setSqPrice,
      SSRM: setSsrmPrice,
      T: setTPrice,
      TEVA: setTevaPrice,
      TM: setTmPrice,
      TMUS: setTmusPrice,
      TRIP: setTripPrice,
      TSLA: setTslaPrice,
      TSM: setTsmPrice,
      TWTR: setTwtrPrice,
      UNH: setUnhPrice,
      V: setVPrice,
      VZ: setVzPrice,
      WFC: setWfcPrice,
      WMT: setWmtPrice,
      XOM: setXomPrice,
    };

    try {
      const prices = await getAllPrices();
      if (!prices || Object.keys(prices).length === 0) return;

      Object.entries(prices).forEach(([symbol, price]) => {
        const setter = priceSetters[symbol];
        if (setter && price != null && !isNaN(price)) {
          setter(price);
        }
      });
    } catch (error) {
      console.warn("Backup price service failed:", error.message);
    } finally {
      backupPricesFetching.current = false;
    }
  }

  async function getAddresses() {
    const docRef = doc(db, "admin", "addresses");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const { Bitcoin, Ethereum, Dogecoin, Tether } = docSnap.data();
      const addressList = [Bitcoin, Ethereum, Dogecoin, Tether];
      setAddresses(addressList);
    } else {
      console.log("No such document!");
    }
  }

  async function getData(id) {
    const docRef = doc(db, "users", id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const {
        firstname,
        lastname,
        id,
        email,
        country,
        admin,
        verified,
        photoURL,
        accountType,
        popup,
        tradingProgress,
        blocked,
      } = docSnap.data();
      const data = {
        firstname,
        lastname,
        id,
        email,
        country,
        admin,
        verified,
        photoURL,
        accountType,
        popup,
        tradingProgress,
        blocked,
      };
      setUserData({
        firstname,
        lastname,
        id,
        email,
        country,
        admin,
        verified,
        photoURL,
        accountType,
        popup,
        tradingProgress,
        blocked,
      });
      return data;
    } else {
      console.log("No such document!");
    }
  }

  async function getProfits(id) {
    // const docRef = doc(db, "profits", id);
    // const docSnap = await getDoc(docRef);

    // if (docSnap.exists()) {
    //   const data = docSnap.data();
    //   const { profits } = data;
    //   setProfits(profits);
    // } else {
    //   console.log("No such document!");
    // }

    onSnapshot(doc(db, "profits", id), (doc) => {
      const data = doc.data();
      const { profits } = data;
      setProfits(profits);
    });
  }

  useEffect(() => {
    if (user && user.uid) {
      onSnapshot(doc(db, "accounts", user.uid), (doc) => {
        setAccounts(doc.data());
      });

      onSnapshot(doc(db, "balance", user.uid), (doc) => {
        const data = doc.data();
        const { signalBalance } = data;
        setSignalBalance(signalBalance);
      });
    }
  }, [user]);

  async function additionalCryptoPrices() {
    const url =
      "https://redstone.p.rapidapi.com/prices?provider=redstone&symbols=1INCH%2CAAVE%2CADA%2CALGO%2CANC%2CAPE%2CAURORA%2CAVAX%2CAXS%2CBCH%2CBTC%2CBTG%2CCRO%2CDAI%2CDAO%2CDASH%2CDOGE%2CDOT%2CETC%2CETH%2CEVMOS%2CGMT%2CGRT%2CGT%2CLINK%2CLN%2CLTC%2CMANA%2CMATIC%2CNEXO%2COGN%2COKB%2COP%2CORN%2CRARI%2CSFP%2CSHIB%2CSOL%2CSUSHI%2CTIME%2CTLOS%2CTRX%2CUNI%2CUSDT%2CVET%2CWING%2CWXT%2CXCN%2CXLM%2CXMR%2CXPR%2CXTZ%2CZEC%2CZIG%2CSFP";

    const config = {
      method: "get",
      headers: {
        "X-RapidAPI-Key": "396a8cb761mshc0459779f675ee6p18d42djsn4cd87cfd13f7",
        "X-RapidAPI-Host": "redstone.p.rapidapi.com",
      },
    };

    try {
      const response = await axios.get(url, config);

      if (response) {
        const { data } = response;

        setOneInchPrice(data["1INCH"].value ?? 0);
        setAavePrice(data.AAVE.value ?? 0);
        setAdaPrice(data.ADA.value ?? 0);
        setAlgoPrice(data.ALGO.value ?? 0);
        setApePrice(data.APE.value ?? 0);
        setAuroraPrice(data.AURORA.value ?? 0);
        setAvaxPrice(data.AVAX.value ?? 0);
        setAxsPrice(data.AXS.value ?? 0);
        setBchPrice(data.BCH.value ?? 0);
        setBtcPrice(data.BTC.value ?? 0);
        setBtgPrice(data.BTG.value ?? 0);
        setCroPrice(data.CRO.value ?? 0);
        setDaiPrice(data.DAI.value ?? 0);
        setDaoPrice(data.DAO.value ?? 0);
        setDashPrice(data.DASH.value ?? 0);
        setDogePrice(data.DOGE.value ?? 0);
        setDotPrice(data.DOT.value ?? 0);
        setEtcPrice(data.ETC.value ?? 0);
        setEthPrice(data.ETH.value ?? 0);
        setGmtPrice(data.GMT.value ?? 0);
        setGrtPrice(data.GRT.value ?? 0);
        setGtPrice(data.GT.value ?? 0);
        setLinkPrice(data.LINK.value ?? 0);
        setLtcPrice(data.LTC.value ?? 0);
        setManaPrice(data.MANA.value ?? 0);
        setMaticPrice(data.MATIC.value ?? 0);
        setNexoPrice(data.NEXO.value ?? 0);
        setOgnPrice(data.OGN.value ?? 0);
        setOkbPrice(data.OKB.value ?? 0);
        setOrnPrice(data.ORN.value ?? 0);
        setOpPrice(data.OP.value ?? 0);
        setRariPrice(data.RARI.value ?? 0);
        setSushiPrice(data.SUSHI.value ?? 0);
        setTimePrice(data.TIME.value ?? 0);
        setTlosPrice(data.TLOS.value ?? 0);
        setTrxPrice(data.TRX.value ?? 0);
        setUniPrice(data.UNI.value ?? 0);
        setVetPrice(data.VET.value ?? 0);
        setWxtPrice(data.WXT.value ?? 0);
        setXcnPrice(data.XCN.value ?? 0);
        setXlmPrice(data.XLM.value ?? 0);
        setXmrPrice(data.XMR.value ?? 0);
        setXprPrice(data.XPR.value ?? 0);
        setXtzPrice(data.XTZ.value ?? 0);
        setZecPrice(data.ZEC.value ?? 0);
        setZigPrice(data.ZIG.value ?? 0);
        setSfpPrice(data.SFP.value ?? 0);
        setShibPrice(data.SHIB.value ?? 0);
        setSolPrice(data.SOL.value ?? 0);
        setUsdtPrice(data.USDT.value ?? 0);
      }
    } catch (error) {
      console.log("error", error);
      applyBackupPrices();
    }
  }

  async function fetchCryptoPrices() {
    const url = `https://redstone.p.rapidapi.com/prices?provider=redstone&symbols=1INCH,AAVE,ALGO,ANC,APE,AURORA,AXS,BTG,ADA,XCN,LINK,CRO,DAI,DAO,DASH,MANA,DFL,ETC,EVMOS,GT,LN,XMR,NEXO,OKB,OP,OGN,ORN,DOT,XPR,RARI,SFP,SHIB,XLM,GMT,SUSHI,TLOS,XTZ,GRT,TRX,UNI,VET,WING,WXT,TIME,ZEC,ZIG,AVAX,BCH,BTC,DOGE,ETH,LTC,MATIC,SOL,USDT,XRP`;

    const config = {
      method: "get",
      headers: {
        "X-RapidAPI-Key": "396a8cb761mshc0459779f675ee6p18d42djsn4cd87cfd13f7",
        "X-RapidAPI-Host": "redstone.p.rapidapi.com",
      },
    };

    try {
      const response = await axios.get(url, config);
      console.log("res", response);
      if (response) {
        const { data } = response;
        console.log("inch", data["1INCH"].value);
        setOneInchPrice(data["1INCH"].value);
        setAavePrice(data.AAVE.value);
        setAdaPrice(data.ADA.value);
        setAlgoPrice(data.ALGO.value);
        setAncPrice(data["ANC"].value);
        setApePrice(data.APE.value);
        setAuroraPrice(data.AURORA.value);
        setAvaxPrice(data.AVAX.value);
        setAxsPrice(data["AXS"].value);
        setBchPrice(data.BCH.value);
        setBtcPrice(data.BTC.value);
        setBtgPrice(data["BTG"].value);
        setCroPrice(data.CRO.value);
        setDaiPrice(data.DAI.value);
        setDaoPrice(data["DAO"].value);
        setDashPrice(data.DASH.value);
        setDogePrice(data.DOGE.value);
        setDotPrice(data.DOT.value);
        setEtcPrice(data["ETC"].value);

        setEthPrice(data.ETH.value);
        setEvmosPrice(data.EVMOS.value);
        setGmtPrice(data.GMT.value);
        setGrtPrice(data.GRT.value);
        setGtPrice(data.GT.value);
        setLinkPrice(data.LINK.value);
        setLnPrice(data.LN.value);
        setLtcPrice(data.LTC.value);
        setManaPrice(data.MANA.value);
        setMaticPrice(data.MATIC.value);

        setNexoPrice(data.NEXO.value);
        setOgnPrice(data["OGN"].value);
        setOkbPrice(data.OKB.value);
        setOrnPrice(data["ORN"].value);
        setOpPrice(data.OP.value);
        setRariPrice(data.RARI.value);
        setSushiPrice(data.SUSHI.value);
        setTimePrice(data.TIME.value);
        setTlosPrice(data.TLOS.value);
        setTrxPrice(data.TRX.value);
        setUniPrice(data.UNI.value);
        setVetPrice(data.VET.value);
        setWingPrice(data["WING"].value);
        setWxtPrice(data.WXT.value);
        setXcnPrice(data.XCN.value);
        setXlmPrice(data.XLM.value);
        setXmrPrice(data.XMR.value);
        setXprPrice(data.XPR.value);

        setXtzPrice(data.XTZ.value);
        setZecPrice(data.ZEC.value);
        setZigPrice(data.ZIG.value);
        setSfpPrice(data.SFP.value);
        setShibPrice(data["SHIB"].value);

        setSolPrice(data.SOL.value);

        setUsdtPrice(data.USDT.value);

        // setXrpPrice(data.XRP.value);
      }
    } catch (error) {
      console.log("error", error);
      applyBackupPrices();
    }
  }

  async function fetchNewCryptoprices() {
    const url = "https://coinranking1.p.rapidapi.com/coins";

    const config = {
      method: "GET",
      params: {
        referenceCurrencyUuid: "yhjMzLPhuIDl",
        timePeriod: "24h",
        orderBy: "price",
        offset: "0",
        limit: "1000",
      },
      headers: {
        "x-rapidapi-key": "396a8cb761mshc0459779f675ee6p18d42djsn4cd87cfd13f7",
        "x-rapidapi-host": "coinranking1.p.rapidapi.com",
      },
    };

    try {
      const response = await axios.get(url, config);
      if (response && response.data && response.data.data) {
        const cryptoData = response.data.data.coins;

        cryptoData.forEach((crypto) => {
          const symbol = crypto.symbol;
          const price = parseFloat(crypto.price);

          switch (symbol) {
            case "1INCH":
              setOneInchPrice(price);
              break;
            case "AAVE":
              setAavePrice(price);
              break;
            case "ADA":
              setAdaPrice(price);
              break;
            case "ALGO":
              setAlgoPrice(price);
              break;
            // case "ANC":
            //   setAncPrice(price);
            //   break;
            case "APE":
              setApePrice(price);
              break;
            case "AURORA":
              setAuroraPrice(price);
              break;
            case "AVAX":
              setAvaxPrice(price);
              break;
            case "AXS":
              setAxsPrice(price);
              break;
            case "BCH":
              setBchPrice(price);
              break;
            case "BTC":
              setBtcPrice(price);
              break;
            case "BTG":
              setBtgPrice(price);
              break;
            case "CRO":
              setCroPrice(price);
              break;
            case "DAI":
              setDaiPrice(price);
              break;
            case "DAO":
              setDaoPrice(price);
              break;
            case "DASH":
              setDashPrice(price);
              break;
            case "DOGE":
              setDogePrice(price);
              break;
            case "DOT":
              setDotPrice(price);
              break;
            case "ETC":
              setEtcPrice(price);
              break;
            case "ETH":
              setEthPrice(price);
              break;
            case "EVMOS":
              setEvmosPrice(price);
              break;
            case "GMT":
              setGmtPrice(price);
              break;
            case "GRT":
              setGrtPrice(price);
              break;
            case "GT":
              setGtPrice(price);
              break;
            case "LINK":
              setLinkPrice(price);
              break;
            case "LN":
              setLnPrice(price);
              break;
            case "LTC":
              setLtcPrice(price);
              break;
            case "MANA":
              setManaPrice(price);
              break;
            case "MATIC":
              setMaticPrice(price);
              break;
            case "NEXO":
              setNexoPrice(price);
              break;
            case "OGN":
              setOgnPrice(price);
              break;
            case "OKB":
              setOkbPrice(price);
              break;
            case "OP":
              setOpPrice(price);
              break;
            case "ORN":
              setOrnPrice(price);
              break;
            case "RARI":
              setRariPrice(price);
              break;
            case "SFP":
              setSfpPrice(price);
              break;
            case "SHIB":
              setShibPrice(price);
              break;
            case "SOL":
              setSolPrice(price);
              break;
            case "SUSHI":
              setSushiPrice(price);
              break;
            case "TIME":
              setTimePrice(price);
              break;
            case "TLOS":
              setTlosPrice(price);
              break;
            case "TRX":
              setTrxPrice(price);
              break;
            case "UNI":
              setUniPrice(price);
              break;
            case "USDT":
              setUsdtPrice(price);
              break;
            case "VET":
              setVetPrice(price);
              break;
            case "WING":
              setWingPrice(price);
              break;
            case "WXT":
              setWxtPrice(price);
              break;
            case "XCN":
              setXcnPrice(price);
              break;
            case "XLM":
              setXlmPrice(price);
              break;
            case "XMR":
              setXmrPrice(price);
              break;
            case "XPR":
              setXprPrice(price);
              break;
            // case "XRP":
            //   setXrpPrice(price);
            //   break;
            case "XTZ":
              setXtzPrice(price);
              break;
            case "ZEC":
              setZecPrice(price);
              break;
            case "ZIG":
              setZigPrice(price);
              break;
          }
        });
      }
    } catch (error) {
      console.log("error", error);
      applyBackupPrices();
    }
  }

  async function fetchExtraPrices() {
    const url = `https://data.alpaca.markets/v1beta1/crypto/snapshots?exchange=ERSX&symbols=BTCUSD,ETHUSD,SOLUSD,BCHUSD,LTCUSD,DOGEUSD,USDTUSD,MATICUSD,AVAXUSD`;

    const config = {
      method: "get",
      headers: {
        "Apca-Api-Key-Id": "PKQ6M7Z27HOJ5JZ6XEGN",
        "Apca-Api-Secret-Key": "J7HXcztjRdTUHB0aGkihTdnTTdLGmiVDstpJNAd5",
      },
    };

    try {
      const response = await axios.get(url, config);
      if (response) {
        const {
          AVAXUSD,
          BCHUSD,
          BTCUSD,
          DOGEUSD,
          ETHUSD,
          LTCUSD,
          MATICUSD,
          SOLUSD,
          USDTUSD,
        } = response.data.snapshots;
        setBtcPrice(BTCUSD.latestTrade.p);
        setEthPrice(ETHUSD.latestTrade.p);
        setSolPrice(SOLUSD.latestTrade.p);
        setBchPrice(BCHUSD.latestTrade.p);
        setLtcPrice(LTCUSD.latestTrade.p);
        setDogePrice(DOGEUSD.latestTrade.p);
        setUsdtPrice(USDTUSD.latestTrade.p);
        setMaticPrice(MATICUSD.latestTrade.p);
        setAvaxPrice(AVAXUSD.latestTrade.p);
      }
    } catch (error) {
      applyBackupPrices();
    }
  }

  async function fetchStockPrices() {
    const url = `https://data.alpaca.markets/v2/stocks/snapshots?symbols=AAPL,ABT,ADBE,ADI,AEMD,AIG,AMC,AMD,AMT,AMZN,APT,ASML,ATER,AXP,BA,BABA,BAC,BIDU,BMY,C,CAT,CCO,CEI,CHWY,CL,CLEU,CMCSA,COST,CRDF,CRM,CSCO,CVX,DIS,EBAY,FB,FSLY,GE,GEVO,GM,GOOGL,GS,HD,HON,IBM,INMD,INTC,JNJ,JPM,KO,LEN,LVS,MA,MDLZ,MMM,MNST,MSFT,MO,MRIN,MRK,MS,MSI,NFLX,NKE,NVDA,NVS,ORCL,PEP,PFE,PG,PYPL,RACE,RKLB,RL,RWLK,SBUX,SNAP,SSRM,SQ,T,TEVA,TM,TMUS,TRIP,TSLA,TSM,TWTR,UNH,V,VZ,WFC,WMT,XOM`;

    const config = {
      method: "get",
      headers: {
        "Apca-Api-Key-Id": "PKQ6M7Z27HOJ5JZ6XEGN",
        "Apca-Api-Secret-Key": "J7HXcztjRdTUHB0aGkihTdnTTdLGmiVDstpJNAd5",
      },
    };

    try {
      const response = await axios.get(url, config);
      if (response) {
        const {
          AAPL,
          ABT,
          ADBE,
          ADI,
          AEMD,
          AIG,
          AMC,
          AMD,
          AMT,
          AMZN,
          APT,
          ASML,
          ATER,
          AXP,
          BA,
          BABA,
          BAC,
          BIDU,
          BMY,
          C,
          CAT,
          CCO,
          CEI,
          CHWY,
          CL,
          CLEU,
          CMCSA,
          COST,
          CRDF,
          CRM,
          CSCO,
          CVX,
          DIS,
          EBAY,
          FB,
          FSLY,
          GE,
          GEVO,
          GM,
          GOOGL,
          GS,
          HD,
          HON,
          IBM,
          INMD,
          INTC,
          JNJ,
          JPM,
          KO,
          LEN,
          LVS,
          MA,
          MDLZ,
          MMM,
          MNST,
          MSFT,
          MO,
          MRIN,
          MRK,
          MS,
          MSI,
          NFLX,
          NKE,
          NVDA,
          NVS,
          ORCL,
          PEP,
          PFE,
          PG,
          PYPL,
          RACE,
          RKLB,
          RL,
          RWLK,
          SBUX,
          SNAP,
          SSRM,
          SQ,
          T,
          TEVA,
          TM,
          TMUS,
          TRIP,
          TSLA,
          TSM,
          TWTR,
          UNH,
          V,
          VZ,
          WFC,
          WMT,
          XOM,
        } = response.data;

        // console.log(response.data);

        setAaplPrice(AAPL.latestTrade.p);
        setAbtPrice(ABT.latestTrade.p);
        setAdbePrice(ADBE.latestTrade.p);
        setAdiPrice(ADI.latestTrade.p);
        setAemdPrice(AEMD.latestTrade.p);
        setAigPrice(AIG.latestTrade.p);
        setAmcPrice(AMC.latestTrade.p);
        setAmdPrice(AMD.latestTrade.p);
        setAmtPrice(AMT.latestTrade.p);
        setAmznPrice(AMZN.latestTrade.p);
        setAptPrice(APT.latestTrade.p);
        setAsmlPrice(ASML.latestTrade.p);
        setAterPrice(ATER.latestTrade.p);
        setAxpPrice(AXP.latestTrade.p);
        setBaPrice(BA.latestTrade.p);
        setBabaPrice(BABA.latestTrade.p);
        setBacPrice(BAC.latestTrade.p);
        setBiduPrice(BIDU.latestTrade.p);
        setBmyPrice(BMY.latestTrade.p);
        setCPrice(C.latestTrade.p);
        setCatPrice(CAT.latestTrade.p);
        setCcoPrice(CCO.latestTrade.p);
        setCeiPrice(CEI.latestTrade.p);
        setChwyPrice(CHWY.latestTrade.p);
        setClPrice(CL.latestTrade.p);
        setCleuPrice(CLEU.latestTrade.p);
        setCmcsaPrice(CMCSA.latestTrade.p);
        setCostPrice(COST.latestTrade.p);
        setCrdfPrice(CRDF.latestTrade.p);
        setCrmPrice(CRM.latestTrade.p);
        setCscoPrice(CSCO.latestTrade.p);
        setCvxPrice(CVX.latestTrade.p);
        setDisPrice(DIS.latestTrade.p);
        setEbayPrice(EBAY.latestTrade.p);
        setFbPrice(FB.latestTrade.p);
        setFslyPrice(FSLY.latestTrade.p);
        setGePrice(GE.latestTrade.p);
        setGevoPrice(GEVO.latestTrade.p);
        setGmPrice(GEVO.latestTrade.p);
        setGooglPrice(GOOGL.latestTrade.p);
        setGsPrice(GS.latestTrade.p);
        setHdPrice(HD.latestTrade.p);
        setHonPrice(HON.latestTrade.p);
        setIbmPrice(IBM.latestTrade.p);
        setInmdPrice(INMD.latestTrade.p);
        setIntcPrice(INTC.latestTrade.p);
        setJnjPrice(JNJ.latestTrade.p);
        setJpmPrice(JPM.latestTrade.p);
        setKoPrice(KO.latestTrade.p);
        setLenPrice(LEN.latestTrade.p);
        setLvsPrice(LVS.latestTrade.p);
        setMaPrice(MA.latestTrade.p);
        setMdlzPrice(MDLZ.latestTrade.p);
        setMmmPrice(MMM.latestTrade.p);
        setMnstPrice(MNST.latestTrade.p);
        setMoPrice(MO.latestTrade.p);
        setMrinPrice(MRIN.latestTrade.p);
        setMrkPrice(MRK.latestTrade.p);
        setMsPrice(MS.latestTrade.p);
        setMsftPrice(MSFT.latestTrade.p);
        setMsiPrice(MSI.latestTrade.p);
        setNflxPrice(NFLX.latestTrade.p);
        setNkePrice(NKE.latestTrade.p);
        setNvdaPrice(NVDA.latestTrade.p);
        setNvsPrice(NVS.latestTrade.p);
        setOrclPrice(ORCL.latestTrade.p);
        setPepPrice(PEP.latestTrade.p);
        setPfePrice(PFE.latestTrade.p);
        setPgPrice(PG.latestTrade.p);
        setPyplPrice(PYPL.latestTrade.p);
        setRacePrice(RACE.latestTrade.p);
        setRklbPrice(RKLB.latestTrade.p);
        setRlPrice(RL.latestTrade.p);
        setRwlkPrice(RWLK.latestTrade.p);
        setSbuxPrice(SBUX.latestTrade.p);
        setSnapPrice(SNAP.latestTrade.p);
        setSqPrice(SQ.latestTrade.p);
        setSsrmPrice(SSRM.latestTrade.p);
        setTPrice(T.latestTrade.p);
        setTevaPrice(TEVA.latestTrade.p);
        setTmPrice(TM.latestTrade.p);
        setTmusPrice(TMUS.latestTrade.p);
        setTripPrice(TRIP.latestTrade.p);
        setTslaPrice(TSLA.latestTrade.p);
        setTsmPrice(TSM.latestTrade.p);
        setTwtrPrice(TWTR.latestTrade.p);
        setUnhPrice(UNH.latestTrade.p);
        setVPrice(V.latestTrade.p);
        setVzPrice(VZ.latestTrade.p);
        setWfcPrice(WFC.latestTrade.p);
        setWmtPrice(WMT.latestTrade.p);
        setXomPrice(XOM.latestTrade.p);
      }
    } catch (error) {
      console.log("error", error);
      applyBackupPrices();
    }
  }

  const currentPrices = {
    // Crypto
    BTC: btcPrice,
    ETH: ethPrice,
    SOL: solPrice,
    BCH: bchPrice,
    LTC: ltcPrice,
    DOGE: dogePrice,
    USDT: Number(usdtPrice),
    USDC: Number(usdtPrice),
    MATIC: maticPrice,
    AVAX: avaxPrice,
    "1INCH": oneInchPrice,
    AAVE: aavePrice,
    ALGO: algoPrice,
    ANC: ancPrice,
    APE: apePrice,
    AURORA: auroraPrice,
    AXS: axsPrice,
    BTG: btgPrice,
    BORING: boringPrice,
    ADA: adaPrice,
    XCN: xcnPrice,
    LINK: linkPrice,
    CMDX: cmdxPrice,
    CRO: Number(croPrice),
    DAI: Number(daiPrice),
    DAO: daoPrice,
    DASH: dashPrice,
    MANA: manaPrice,
    DFL: dflPrice,
    NRG: nrgPrice,
    ETC: etcPrice,
    EVMOS: evmosPrice,
    GT: gtPrice,
    GO: goPrice,
    LN: lnPrice,
    XMR: xmrPrice,
    NEXO: nexoPrice,
    OKB: okbPrice,
    OP: opPrice,
    OGN: ognPrice,
    ORN: ornPrice,
    DOT: dotPrice,
    XPR: xprPrice,
    RAINI: rainiPrice,
    RARI: rariPrice,
    SFP: sfpPrice,
    SHIB: shibPrice,
    XLM: xlmPrice,
    STEP: stepPrice,
    GMT: gmtPrice,
    SUSHI: sushiPrice,
    TLOS: tlosPrice,
    XTZ: xtzPrice,
    GRT: grtPrice,
    TRX: trxPrice,
    UNI: uniPrice,
    VET: vetPrice,
    WING: wingPrice,
    WXT: wxtPrice,
    TIME: timePrice,
    ZEC: zecPrice,
    ZIG: zigPrice,

    // Stocks
    AAPL: aaplPrice,
    ABT: abtPrice,
    ADBE: adbePrice,
    ADI: adiPrice,
    AEMD: aemdPrice,
    AIG: aigPrice,
    AMC: amcPrice,
    AMD: amdPrice,
    AMT: amtPrice,
    AMZN: amznPrice,
    APT: aptPrice,
    ASML: asmlPrice,
    ATER: aterPrice,
    AXP: axpPrice,
    BA: baPrice,
    BABA: babaPrice,
    BAC: bacPrice,
    BIDU: biduPrice,
    BMY: bmyPrice,
    C: cPrice,
    CAT: catPrice,
    CCO: ccoPrice,
    CEI: ceiPrice,
    CHWY: chwyPrice,
    CL: clPrice,
    CLEU: cleuPrice,
    CMCSA: cmcsaPrice,
    COST: costPrice,
    CRDF: crdfPrice,
    CRM: crmPrice,
    CSCO: cscoPrice,
    CVX: cvxPrice,
    DIS: disPrice,
    EBAY: ebayPrice,
    FB: fbPrice,
    FSLY: fslyPrice,
    GE: gePrice,
    GEVO: gevoPrice,
    GM: gmPrice,
    GOOGL: googlPrice,
    GS: gsPrice,
    HD: hdPrice,
    HON: honPrice,
    IBM: ibmnPrice,
    INMD: inmdPrice,
    INTC: intcPrice,
    JNJ: jnjPrice,
    JPM: jpmPrice,
    KO: koPrice,
    LEN: lenPrice,
    LVS: lvsPrice,
    MA: maPrice,
    MDLZ: mdlzPrice,
    MMM: mmmPrice,
    MNST: mnstPrice,
    MO: moPrice,
    MRIN: mrinPrice,
    MRK: mrkPrice,
    MS: msPrice,
    MSFT: msftPrice,
    MSI: msiPrice,
    NFLX: nflxPrice,
    NKE: nkePrice,
    NVDA: nvdaPrice,
    NVS: nvsPrice,
    ORCL: orclPrice,
    PEP: pepPrice,
    PFE: pfePrice,
    PG: pgPrice,
    PYPL: pyplPrice,
    RACE: racePrice,
    RKLB: rklbPrice,
    RL: rlPrice,
    RWLK: rwlkPrice,
    SBUX: sbuxPrice,
    SNAP: snapPrice,
    SQ: sqPrice,
    SSRM: ssrmPrice,
    T: tPrice,
    TEVA: tevaPrice,
    TM: tmPrice,
    TMUS: tmusPrice,
    TRIP: tripPrice,
    TSLA: tslaPrice,
    TSM: tsmPrice,
    TWTR: twtrPrice,
    UNH: unhPrice,
    V: vPrice,
    VZ: vzPrice,
    WFC: wfcPrice,
    WMT: wmtPrice,
    XOM: xomPrice,

    // Fiat
    USD: 1,
  };

  useEffect(() => {
    if (accounts && currentAccount) {
      const { live, practice } = accounts;
      switch (currentAccount) {
        case "practice": {
          setAccount(practice);
          break;
        }
        case "live":
          setAccount(live);
          break;
        default:
          break;
      }
    }
  }, [currentAccount, account, accounts, live, practice]);

  useEffect(() => {
    if (account && live && practice) {
      const { Stock, Crypto, Fiat } = account;

      if (Stock && Crypto && Fiat) {
        const CryptoAccount = Object.values(Crypto);
        const StockAccount = Object.values(Stock);

        function getTotalCrypto() {
          let CryptoTotal = 0;
          for (let i = 0; i < CryptoAccount.length; i++) {
            const price =
              currentPrices[CryptoAccount[i].asset] * CryptoAccount[i].value;
            CryptoTotal = CryptoTotal + price;
          }
          setCryptoTotal(CryptoTotal);
        }

        setFiatTotal(Fiat.value);

        function getTotalStocks() {
          let StockTotal = 0;
          for (let i = 0; i < StockAccount.length; i++) {
            const price =
              currentPrices[StockAccount[i].asset] * StockAccount[i].value;
            StockTotal = StockTotal + price;
          }
          setStockTotal(StockTotal);
        }

        getTotalCrypto();
        getTotalStocks();
      }
    }
  }, [account, live, practice, currentPrices]);

  useEffect(() => {
    setTotalBalance(stockTotal + cryptoTotal + fiatTotal);
  }, [stockTotal, cryptoTotal, fiatTotal, totalBalance]);

  useEffect(() => {
    function getAccounts() {
      if (live && practice) {
        setLive(live);
        setPractice(practice);
      }
    }

    if (user && accounts) {
      getAccounts(user.uid);
    }
  }, [user, accounts, live, practice, currentPrices]);

  useEffect(() => {
    if (!loading && user) {
      getData(user.uid);
      getAddresses();
      getProfits(user.uid);
    }

    applyBackupPrices();
    fetchStockPrices();
    fetchNewCryptoprices();
    additionalCryptoPrices();
  }, [user, loading]);

  return (
    <MoralisProvider
      serverUrl="https://t4rrurk2rwxu.usemoralis.com:2053/server"
      appId="WY0o08tyf41tHZEmveE8hy7xXjxhBIMz9nBzB9cs"
    >
      <userContext.Provider
        value={{
          currentUser: state.currentUser,
          dispatch,
          userData,
          accounts,
          getData,
          currentPrices,
          currentAccount: state.currentAccount,
          totalBalance,
          account,
          currentWallet: state.currentWallet,
          signalBalance,
          profits,
          addresses,
        }}
      >
        {children}
      </userContext.Provider>
    </MoralisProvider>
  );
};

export default Provider;
